import React from 'react';
import ExcelJS from 'exceljs';
import ls from 'local-storage';
import { CButton } from '@coreui/react';

function titleCase(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(' ');
}

function SummaryDownload(props) {
  const handlerClickDownloadButton = async () => {
    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet('sheet1', {
      headerFooter: {
        firstHeader: 'Hello Exceljs',
        firstFooter: 'Hello World'
      }
    });

    const worksheet = workbook.getWorksheet('sheet1');

    worksheet.columns = [
      { header: 'Data', key: 'Total', width: '30' },
      { header: 'Total', key: 'Amount', width: '30' }
    ];

    worksheet.addRow({
      Total: '',
      Amount: ''
    });

    const data = Object.getOwnPropertyNames(props.summaryData);
    const dataValues = Object.values(props.summaryData);
    const mappedData = data.map((item, index) => {
      const title = item.split('_').join(' ');
      let data = dataValues[index] ?? 0;
      if (
        item.includes('_count') ||
        item.includes('charge_xendit_percentage')
      ) {
        data = dataValues[index];
      } else {
        data = new Intl.NumberFormat('id-ID', {
          style: 'currency',
          currency: 'IDR'
        }).format(dataValues[index]);
      }

      return worksheet.addRow({
        Total: titleCase(title),
        Amount: data
      });
    });

    const uint8Array = await workbook.xlsx.writeBuffer();
    const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    let fileName =
      'Summary ' +
      ' ' +
      props.dateFrom +
      ' sampai ' +
      props.dateUntil +
      '.xlsx';
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();
  };

  return (
    <>
      <CButton
        // disabled={props..length === 0 ? true : false}
        onClick={(e) => handlerClickDownloadButton()}
        style={{ backgroundColor: '#4E5B97', border: 'none' }}
      >
        Download Summary
      </CButton>
    </>
  );
}

export default SummaryDownload;
